import Axios from "axios";
import config from "../config";


class CompanyService {
  constructor() {
    this.api = Axios.create({
      baseURL: config.URL_ENDPOINT,
    });
  }

  async getCompanies() {
    try {
      const response = await this.api.get(`/instituicoes/all/`);
      const data = response.data;

      return data;
    } catch (error) {
      console.error("Erro ao buscar instituições", error);
      throw error;
    }
  }
  async getCompaniesByIdent(payload) {
    try {
      const response = await this.api.post(`/totem-app/instituicoes`, payload);
      const data = response.data;

      return data;
    } catch (error) {
      console.error("Erro ao buscar instituições", error);
      throw error;
    }
  }

  async getVisitorsReasons() {
    try {
      const response = await this.api.get(`/motivos-visita/`);
      const {data} = response.data;

      return data;
    } catch (error) {
      console.error("Erro ao buscar motivos de visita", error);
      throw error;
    }
  }

  async getDepartments(id){
    try {
      const response = await this.api.get(`/setores/all/${id}`);
      const {data} = response.data;

      return data;
    } catch (error) {
      console.error("Erro ao buscar departamentos", error);
      throw error;
    }
  }

  async nonScheduledVisitors(payload) {
    try {
      const response = await this.api.post(`/visitante-sem-agendamento`, payload);
      const data = response.data;
      return data;
    } catch (error) {
      console.error("Erro ao buscar visitantes não agendados", error);
      throw error;
    }
  }

  async callReception(payload) {
    try {
      const response = await this.api.post(`/totem/acionar-recepcao`, payload);
      const data = response.data;
      return data;
    } catch (error) {
      console.error("Erro ao chamar recepção", error);
      throw error;
    }
}
}

export default CompanyService;